import React, { useState } from 'react';
import JsonView from '@uiw/react-json-view';

export const CollapsibleJson = ({ data, title = 'Onboarding Data', defaultOpen = false }) => {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <div>
            <button
                onClick={() => setOpen(!open)}
                className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 text-sm underline mb-2"
            >
                {open ? 'Hide' : 'Show'} {title}
            </button>
            {open && (
                <div className="bg-gray-100 dark:bg-slate-800 p-3 rounded overflow-auto max-h-64">
                    <JsonView value={data || {}} className="dark:bg-slate-800 dark:text-slate-200" />
                </div>
            )}
        </div>
    );
};
